import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { buttonTypographySx } from '../../../styles/patterns';

export const PreviewPatternButton = ({ loading, onGetPatternClick }) => {
	return (
		<Tooltip
			title={
				<Typography variant="h6">
					Only part of your pattern will be generated
				</Typography>
			}
		>
			<Button
				variant="text"
				color="primary"
				size="medium"
				disabled={loading}
				sx={{ margin: '10px' }}
				onClick={onGetPatternClick}
			>
				<Typography variant="h5" sx={buttonTypographySx}>
					Preview Pattern
				</Typography>
			</Button>
		</Tooltip>
	);
};
